function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.416 4.987L8.333.417l7.917 4.57",
  stroke: "currentColor",
  strokeWidth: 0.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.333 9.583v9.039L.416 14.066V5",
  stroke: "currentColor",
  strokeWidth: 0.6,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.268 3.255L5.418 7.79v4.287l-1.039-1.399-1.045.197V6.538l7.915-4.57M5.6 7.979l2.734 1.578M.416 4.988l2.958 1.707",
  stroke: "currentColor",
  strokeWidth: 0.6,
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.361 11.057a3.75 3.75 0 11-5.303 5.303 3.75 3.75 0 015.303-5.303v0z",
  stroke: "currentColor",
  strokeWidth: 0.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.361 16.36l3.333 3.333M16.25 9.583V4.988L8.335 9.557v9.065l2.205-1.27",
  stroke: "currentColor",
  strokeWidth: 0.6,
  strokeLinejoin: "round"
});

var SvgSendungsverfolgung = function SvgSendungsverfolgung(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default "data:image/svg+xml;base64,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";
export { SvgSendungsverfolgung as ReactComponent };